import * as React from "react";
import Autocomplete from 'react-autocomplete'

export default ({ ...props }) => {
    if (props.closedUntilChange) {
        props.open = false
    }
    return <Autocomplete
        {...props}
        wrapperStyle={{}}
        inputProps={{
            id: "input-autocomplete",
            className: "input",
            placeholder: "Type to quickly find a task..."
        }}
        getItemValue={(item) => item.id}
        menuStyle={{
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: 0,
            position: 'fixed',
            // top: 0,
            // left: 0,
            overflow: 'auto',
            maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
            zIndex: 1000,
        }}
        autoHighlight={true}
        shouldItemRender={(task, value) => {
            if (value === "") return true;
            let values = value.toLowerCase().split(" ");
            let matches = 0;
            for (let value of values) {
                if (task.name.toLowerCase().indexOf(value) > -1 ||
                    task.client.name.toLowerCase().indexOf(value) > -1 ||
                    task.project.name.toLowerCase().indexOf(value) > -1) {
                    matches++;
                }
            }
            return matches === values.length;
        }}
        renderItem={(item, isHighlighted) =>
            <div className="task"
                 style={{background: isHighlighted ? '#ECEFF1' : 'white'}}
                 key={item.id}>
                <span className="client">{item.client.name}</span>
                <span className="project">{item.project.name}</span>
                <span className="name">{item.name}</span>
            </div>
        }
        name="task_id"
        sortItems={(a, b) => {
            return a.client.name + a.project.name + a.name > b.client.name + b.project.name + b.name;
        }}

    />
}


// WEBPACK FOOTER //
// ./src/components/AutocompleteSearch.js